import { render, staticRenderFns } from "./RoleEditDialog.vue?vue&type=template&id=0a534487&"
import script from "./RoleEditDialog.vue?vue&type=script&lang=ts&"
export * from "./RoleEditDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports